import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WithdrawalcoinPage } from './withdrawalcoin';

@NgModule({
  declarations: [
    WithdrawalcoinPage,
  ],
  imports: [
    IonicPageModule.forChild(WithdrawalcoinPage),
  ],
})
export class WithdrawalcoinPageModule {}



// WEBPACK FOOTER //
// ./src/pages/withdrawalcoin/withdrawalcoin.module.ts